module.exports = __webpack_public_path__ + "static/img/0771.07305c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0771.jpg
// module id = 109
// module chunks = 0